/**
 * @author        woody@zumper.com (Woody Anderson)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Pricing Info objects
 */

import type { Pricing as PricingType, RawPricing } from '@zcode/state-type'
import { Bizo, autoclass } from '../../shared/bizos/base'

export const DEFINITION = {
  avgPpb: 'avg_ppb',
  avgPrice: 'avg_price',
  bedrooms: 'bedrooms',
  cardinality: 'cardinality',
  medianPpb: 'median_ppb',
  medianPrice: 'median_price',
  stddevPrice: 'stddev_price',
  pricePercentileMax: 'price_percentile_max',
  pricePercentileMin: 'price_percentile_min',
} as const

const Pricing = autoclass<PricingType, RawPricing>(
  'Pricing',
  class Pricing extends Bizo<PricingType, RawPricing> {},
  DEFINITION,
  null
)
export default Pricing

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class Prices {
  on: any | undefined
  minPrice: number | undefined
  maxPrice: number | undefined

  constructor(array: any[]) {
    this.on = array[0]
    this.minPrice = array[1]
    this.maxPrice = array[2]
  }
}
